/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EfactInvoice } from './EfactInvoice'
import { InvoiceSender } from './InvoiceSender'

export class InvoicesBatch {
  constructor(json: JSON | any) {
    Object.assign(this as InvoicesBatch, json)
  }

  invoicingYear?: number
  invoicingMonth?: number
  fileRef?: string
  batchRef?: string
  ioFederationCode?: string
  uniqueSendNumber?: number
  sender?: InvoiceSender
  numericalRef?: number
  invoices?: Array<EfactInvoice>
}
